
  import React from "react"
  import Component from "/Users/tshohe/Work/git/starter-gatsby-blog/src/layouts/index.js"
  import data from "/Users/tshohe/Work/git/starter-gatsby-blog/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js